export const staticdata = {
  // paystackkeytest: "pk_test_4bd35154ba3b7968932f25aea08901f3d39b787b",
  paystackkeytest: "pk_live_4dabbcc1a3c405e3e1cb3ad759f543aed424693c",
  paystackkeylive: "pk_live_4dabbcc1a3c405e3e1cb3ad759f543aed424693c"
};
